import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import {
  getInitialLoadIcons,
  SetFontSize,
  ZeeFontBold,
  ZeeFontRegular
} from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { MediaBP as MQ } from '../../styles/mediaQuery';
import { notasansMedium } from '../../fonts/customFontsConfig';

export const showDescription = css`
  ${flex()};
`;

export const arrow = css`
  padding: 0;
  font-size: 2.8rem;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
`;

export const text = css`
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  max-height: 61px;
  letter-spacing: -0.43px;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  ${SetFontSize(12, 20)};
  ${MQ.MediaMd} {
    max-height: 72px;
  }
  ${MQ.MediaLg} {
    max-height: 80px;
  }
`;

export const unclamp = css`
  -webkit-line-clamp: unset;
  height: auto;
  max-height: fit-content;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const arrowHandlerWrap = css`
  width: 100%;
`;

export const hyperLinkContainer = css`
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  text-align: justify;
  ${ZeeFontRegular(12, 18)};
  padding: 0px 12px 5px 0;
  strong {
    ${ZeeFontBold(12, 18)};
  }
  title {
    display: none;
  }
  h1 {
    margin: 22px 0;
    ${ZeeFontBold(16, 20)};
  }
  p {
    margin: 0 0 16px;
    &:last-child {
      margin: 0;
    }
  }
  a {
    color: ${colors.PurpleLight};
    text-decoration: none;
  }
  .paraTitles,
  h2 {
    ${ZeeFontBold(14, 20)};
    margin-bottom: 10px;
  }

  h3 {
    ${ZeeFontBold(12, 16)};
    margin-bottom: 5px;
  }

  .bold_text {
    font-family: ${notasansMedium.style.fontFamily}, sans-serif;
  }
  /* Min width 900 - Max width 1199 */
  ${MQ.MediaMd} {
    font-size: 14px;
    line-height: 22px;
    strong {
      font-size: 14px;
      line-height: 22px;
    }
    p {
      margin: 0 0 22px;
    }
    .paraTitles,
    h2 {
      font-size: 16px;
      line-height: 22px;
    }
    h3 {
      font-size: 14px;
      line-height: 22px;
    }
  }

  /* Min width 1200 - Max width 1799 */
  ${MQ.MediaMd} {
    p {
      margin: 0 0 24px;
    }
    .paraTitles,
    h2 {
      font-size: 18px;
      line-height: 24px;
    }
  }

  /* Min width 1800 - Above */
  ${MQ.MediaXl} {
    p {
      margin: 0 0 30px;
    }
    .paraTitles,
    h2 {
      font-size: 20px;
      line-height: 26px;
    }
  }
`;

export const moreAndLessIcon = (
  showMoreDescription: boolean,
  pageType: string
) => css`
  ${getInitialLoadIcons(InitialLoadIconsSet.EXPAND_MORE)};
  transform: rotate(${showMoreDescription ? 180 : 0}deg);
  cursor: pointer;
  color: ${colors.PrimaryWhiteColor};
  &:before {
    font-size: 30px;
  }
  font-size: 12px;
  font-weight: 400;
  color: ${colors.PrimaryGreyColorAlpha0};
  ${pageType === 'celebs'
    ? `color: ${colors.PurpleLight}`
    : `color: ${colors.PrimaryGreyColorAlpha0}`}
`;

export const seoDescriptionContainerCollapse = (
  showMoreDescription: boolean
) => css`
  ${!showMoreDescription
    ? `max-height: 80px;
    overflow: hidden;
    ${MQ.MediaLg} {
      max-height: 95px;
    }
  `
    : ``}
`;

export const seoDescriptionContainer = (pageType: string) => css`
  background-color: ${colors.AccentShowDetailsInfoBg};
  margin: 20px 16px 0 16px;
  ${pageType === 'celebs' ? 'border-radius: 8px' : ''}
  ${MQ.MediaSm} {
    margin: 0;
    margin-top: 20px;
  }
  ${flex('row', 'center', 'baseline')};
  padding: 10px 8px 10px 16px;
  color: ${colors.AccentSubscriptionCodGrayColor};
  margin-bottom: 24px;
  ${MQ.MediaSm} {
    padding: 10px 12px 10px 16px;
  }

  ${MQ.MediaLg} {
    margin-bottom: 32px;
    padding: 10px 32px 10px 32px;
  }
`;
